var _templateObject, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import styled from '@emotion/styled';
import MUISvgIcon, { svgIconClasses } from '@mui/material/SvgIcon';
import * as React from "react";
var SvgIcon = styled(MUISvgIcon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.", " {\n    width: ", ";\n    height: ", ";\n    color: ", ";\n    stroke-width: 1px;\n    vector-effect: non-scaling-stroke;\n  }\n"])), svgIconClasses.root, function (_ref) {
  var size = _ref.size,
    theme = _ref.theme;
  return size && theme.size[size];
}, function (_ref2) {
  var size = _ref2.size,
    theme = _ref2.theme;
  return size && theme.size[size];
}, function (_ref3) {
  var color = _ref3.color,
    theme = _ref3.theme;
  return color && theme.color[color];
});
var SvgDownloadAction = function SvgDownloadAction(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.867 4.8c0-.477-.197-.935-.547-1.273A1.9 1.9 0 0 0 12 3c-.495 0-.97.19-1.32.527-.35.338-.547.796-.547 1.273v4.5h-2.8a.96.96 0 0 0-.52.151.9.9 0 0 0-.344.404.87.87 0 0 0 .204.982l4.666 4.5a.94.94 0 0 0 .661.265.96.96 0 0 0 .66-.265l4.668-4.5a.9.9 0 0 0 .256-.461.87.87 0 0 0-.053-.52.9.9 0 0 0-.345-.405.96.96 0 0 0-.52-.151h-2.8zM6.4 18.3c-.371 0-.727.142-.99.395-.263.254-.41.597-.41.955s.147.701.41.955c.263.253.619.395.99.395h11.2c.371 0 .727-.142.99-.395.262-.254.41-.597.41-.955s-.148-.701-.41-.955a1.43 1.43 0 0 0-.99-.395z",
    clipRule: "evenodd"
  }))));
};
export default SvgDownloadAction;